import { createStore } from "zustand";

export interface AmplitudeStore {
	/**
	 * Prefixes for the event name. Sorted alphabetically for consistency.
	 */
	prefixes: Set<string>;
	data: Record<string, any>;
	addData: (data: Record<string, any>) => void;
	clearKeys: (keys: string[]) => void;
	addPrefix: (prefix: string) => void;
	removePrefix: (prefix: string) => void;
}

const AmplitudeStore = createStore<AmplitudeStore>((set) => ({
	data: {},
	addData: (data) =>
		set((state) => {
			const newData = { ...state.data, ...data };
			for (const key in newData) {
				if (newData[key] == null) {
					delete newData[key];
				}
			}
			return { data: newData };
		}),
	clearKeys: (keys) =>
		set((state) => {
			const data = { ...state.data };
			keys.forEach((key) => delete data[key]);
			return { data };
		}),
	prefixes: new Set(),
	addPrefix: (prefix) =>
		set((state) => {
			state.prefixes.add(prefix);
			return { prefixes: state.prefixes };
		}),
	removePrefix: (prefix) =>
		set((state) => {
			state.prefixes.delete(prefix);
			return { prefixes: state.prefixes };
		}),
}));

export const amplitudeAddData = (data: Record<string, any>) =>
	AmplitudeStore.getState().addData(data);

export const amplitudeClearKeys = (keys: string[]) => AmplitudeStore.getState().clearKeys(keys);

export default AmplitudeStore;
